import ReactDOM from 'react-dom'
import { useState } from 'react'
import { ATTRIBUTE_VIEW, RELATION_VIEW } from 'Types'
import { Input, Modal, notification, Typography } from 'antd'
import { removeElem } from 'Services/WeaverUtils'
{ Text } = Typography

displayKeyEditorFeedback = (type, hasError) ->
  successFeedback = {
    message: "#{type} changed successfully"
    description: """
      The database has been updated. If you wish to see the updated keys in your project,
      please refresh the page.
    """
  }

  errorFeedback = {
    message: "Cannot change this #{type.toLowerCase()}"
    description: """
      The weaver transform plugin encountered an error while transforming this #{type.toLowerCase()}.
      Please contact an administrator for assistance.
    """
  }

  if hasError then notification.error(errorFeedback) else notification.success(successFeedback)

changeRelationKeys = (currentKey, newKey) ->
  relevantNodes = await new Weaver.Query()
    .hasRelationOut(currentKey)
    .notInGraph('$config')
    .unlimited()

  try
    nodeBatch = relevantNodes.map((n) ->
      n.changeRelationKey(currentKey, newKey)
      n
    )
    await Weaver.Node.batchSave(nodeBatch, { commitMessage: "Change relation key #{ currentKey } to #{ newKey }." })
    displayKeyEditorFeedback('Relation', false)
  catch
    displayKeyEditorFeedback('Relation', true)

export default showKeyEditorModal = (currentKey, type) ->

  modalContainer = document.createElement('div')
  document.body.append(modalContainer)

  KeyEditorModal = ({ currentKey, type, container }) ->

    [visible, setVisible] = useState(true)
    [newKey, setNewKey] = useState(undefined)

    parseMagicString = (str) ->
      str.split('_')[0].toLowerCase()

    changeAttributeKeys = ->
      p = await Weaver.Plugin.load('weaver-transform')
      obj = {
        'orderedTransformations': [{
          'change_attribute_keys': [[currentKey, newKey]]
        }]
      }

      try
        p.transformFromJson(obj)
        displayKeyEditorFeedback('Attribute', false)
      catch
        displayKeyEditorFeedback('Attribute', true)

    changeKeys = ->
      if type is RELATION_VIEW
        changeRelationKeys(currentKey, newKey)
      else if type is ATTRIBUTE_VIEW
        changeAttributeKeys()

    content = (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <Text>
          Type the new { parseMagicString(type) } key in the field below, then click 'Ok' to save the changes.
        </Text>
        <br/><br/>
        <Text type="danger">
          Warning: This change will affect each <b>{ currentKey }</b> { parseMagicString(type) }
        </Text>
        <Input
          data-testid="change-key-input-#{currentKey}"
          style={{ marginTop: '20px' }}
          defaultValue={currentKey}
          onChange={(e) -> setNewKey(e.target.value)}
        />
      </div>
    )

    <Modal
      visible={visible}
      className="edit-attr-rel-keys-modal"
      closable={false}
      afterClose={-> removeElem(container)}
      width={Math.max(500, window.innerWidth * .5)}
      title={<h4>Edit <b>{ currentKey }</b></h4>}
      centered={true}
      onCancel={(e) -> setVisible(false)}
      onOk={(e)->
        changeKeys() if not _.isEmpty(newKey)
        setVisible(false)
      }
    >
      { content }
    </Modal>

  ReactDOM.render(
    <KeyEditorModal
      currentKey={currentKey}
      type={type}
      container={modalContainer}
    />
  , modalContainer)

